<template>
  <div>
      {{linkManage ? 'Cách tính xem chi tiết' : 'Hướng dẫn cách tính thuế' }} <a style="color: #409EFF;" :href="link" target="_blank">TẠI ĐÂY</a>
  </div>
</template>

<script>
export default {
  name: "LinkInstruct",
  props: {
    link: {
      type: String,
      default: "",
    },
      linkManage: {
      type: Boolean,
      default: false,
    },
  },

  methods: {},
};
</script>

<style scoped></style>
